import { request } from "@/utils/request";
import { versionfn } from "@/utils/version";

const version = versionfn.version;

// 根据站点 ID 获取 accessKey 和后端生成的外站跳转地址。
export function getSiteAuthAccessKey(siteId) {
  return request({
    url: `${version}/siteauth/redirect`,
    method: "get",
    params: { siteId },
  });
}
